module.exports = __webpack_public_path__ + "static/media/success_illustration.d23d7364.png";